import window from 'ember-window-mock';

declare global {
  interface Window {
    ApplePaySession?: {
      canMakePayments: () => boolean;
    };
  }
}

export function isDeviceApplePayEnabled() {
  try {
    return window.ApplePaySession && window.ApplePaySession.canMakePayments();
  } catch {
    return false;
  }
}
